// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "-" + {"12":"90fa3024","175":"a7fcf0c5","233":"97bd9b64","369":"dd899656","777":"d85915b3","936":"72675f5d"}[chunkId] + ".js";
};